export class TipoFase {
  id: string;
  descrizione: string;
  label: string;
  rimosso: boolean;
}
